<template>
  <v-container class="pa-4">
    <v-row>
      <v-col
        cols="6"
        md="6"
        sm="6"
      >
        <h2>配送データ一括作成</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="3"
      >
        <v-select
          label="配送製品カテゴリ"
          :items=$store.getters.deliveryItemCategories
          item-text="name"
          item-value="id"
          v-model="params.deliveryitemdetail__deliveryitem__deliveryitemcategory"
        >
        </v-select>
      </v-col>
      <v-col
        cols="3"
      >
        <v-select
          label="配送製品"
          :items="search_deliveryitems"
          item-text="name"
          item-value="id"
          v-model="params.deliveryitemdetail__deliveryitem"
        >
        </v-select>
      </v-col>
      <v-col
        cols="3"
      >
        <v-select
          label="配送製品明細"
          :items="search_deliveryitemdetails"
          item-text="name"
          item-value="id"
          v-model="params.deliveryitemdetail_id"
          :error-messages="validation_errors.deliveryitemdetail_id"
        >
        </v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-menu
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              label="*配送日"
              readonly
              v-on="on"
              v-model="params.delivery_date"
              :error-messages="validation_errors.delivery_date"
            ></v-text-field>
          </template>
          <v-date-picker
            locale="ja"
            no-title
            @input="fromDateMenu = false"
            v-model="params.delivery_date"
          ></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="2"
      >
        <v-btn
          class="title-btn mr-4 red white--text"
          @click="confirm"
        >
          一括作成
        </v-btn>
        <confirm-dialog
          ref="confirm"
          title="配送データ一括作成"
          message="選択した製品の配送データを作成しますか？"
          buttonMessage="作成する"
          @confirm="createShippings"
        >
        </confirm-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ConfirmDialog from '@/components/ConfirmDialog'

export default {
  components: {
    'confirm-dialog': ConfirmDialog,
  },
  data() {
    return {
      loading: false,
      params: {
        "deliveryitemdetail__deliveryitem__deliveryitemcategory": null,
        "deliveryitemdetail__deliveryitem": null,
        "deliveryitemdetail_id": null,
        "delivery_date": null,
      },
      validation_errors: {},
      search_deliveryitems: [],
      search_deliveryitemdetails: [],
    }
  },
  watch: {
    'params.deliveryitemdetail__deliveryitem__deliveryitemcategory': async function(val) {
      if (val) {
        try {
          const response = await this.$axios.get(
            `${process.env.VUE_APP_API_URL_BASE}/api/products/deliveryitems/`,
            {
              params: {'deliveryitemcategory': val},
              headers: {
                Authorization: `JWT ${this.$store.getters.token}`,
              },
            },
          )
          this.search_deliveryitems = response.data.results;
        } catch(error) {
          const error_status = error.response.status;
          if (error_status == 401) {
            this.$store.dispatch('userLogout');
          }
          this.$store.dispatch('setSnackbar', {message: "取得に失敗しました", type: "error"});
        }
      } else {
        this.search_deliveryitems = []
      }
    },
    'params.deliveryitemdetail__deliveryitem': async function(val) {
      if (val) {
        try {
          const response = await this.$axios.get(
            `${process.env.VUE_APP_API_URL_BASE}/api/products/deliveryitems/${val}/details/`,
            {
              headers: {
                Authorization: `JWT ${this.$store.getters.token}`,
              },
            },
          )
          this.search_deliveryitemdetails = response.data;
        } catch(error) {
          const error_status = error.response.status;
          if (error_status == 401) {
            this.$store.dispatch('userLogout');
          }
          this.$store.dispatch('setSnackbar', {message: "取得に失敗しました", type: "error"});
        }
      } else {
        this.search_deliveryitemdetails = [];
      }
    },
  },
  methods: {
    confirm() {
      this.$refs.confirm.open();
    },
    async createShippings() {
      try {
        await this.$axios.post(
          `${process.env.VUE_APP_API_URL_BASE}/api/sub/bulkshippings/`,
          this.params,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        );
        this.$store.dispatch('setSnackbar', {message: "作成されました", type: "success"});
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.validation_errors = error.response.data;
        this.$store.dispatch('setSnackbar', {message: "作成できませんでした", type: "error"});
      }
    },
  }
}
</script>